import { useMeQuery } from '@/src/features/auth/services/useMeQuery'

import { isGranted } from './isGranted'
import type { TPermissionKey, TPermissionsMap } from './permissions'

export const useMakeIsGranted = () => {
  const { data: me } = useMeQuery()

  return {
    isGranted: (permission: TPermissionKey, permissionsMap?: Omit<TPermissionsMap, 'user'>) => {
      if (!permissionsMap) return false
      return isGranted(permission, { ...permissionsMap, user: { admin: !!me?.admin } })
    },
  }
}
